import React from "react";
import { ShopForEssentialsCard } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import { ShopEssentials, ShopEssentialsItem } from "@/components/PageHome/api/interface";
import SectionHeader from "@/components/SectionHeader";
import { NEXT_PUBLIC_PHARMACY_BASE_URL } from "@/libs/constants/auth";
import ButtonLink from "@/components/ButtonLink";
import { DeviceInfo } from "@/interface/deviceInfo";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { getPlainTexts } from "@/helpers";
import { useAppSelector } from "@/redux/hooks";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS } from "@/helpers/constants";
import styles from "./Shop.module.scss";

interface ShopProps {
  data: ShopEssentials;
  userAgent: DeviceInfo;
  assetPosition?: number;
}

const Shop: React.FC<ShopProps> = ({ data, userAgent, assetPosition }) => {
  const { Title, Description, Categories } = data;
  const categories = Categories?.data;
  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <section className={`${styles.root}`}>
      <div className={"container"}>
        <SectionHeader title={Title} subTitle={Description} userAgent={userAgent} />
        {!!categories?.length && (
          <div className={styles.contentBx}>
            {categories.map(({ id, attributes }: ShopEssentialsItem, index) => {
              const { CategoryName, ShoppingDesc, ShopApiUrl, ShoppingImage } = attributes;

              return (
                <div key={id} className={styles.shopCategory}>
                  <ShopForEssentialsCard
                    title={CategoryName}
                    rawSubTitle={ShoppingDesc}
                    imageUrl={ShoppingImage?.data?.attributes?.url}
                    cardBackground={index % 2 === 0 ? "#F9E7D2" : "#CED7FF"}
                    buttomColor={userAgent.isMobile ? (index % 2 === 0 ? "#EA5C0D" : "#121414") : "#121414"}
                    buttonBgColor={userAgent.isDesktop && "#fff"}
                    buttonBorderColor={userAgent.isDesktop && "#fff"}
                    onCtaClick={() => {
                      assetClickedEvent({
                        asset_name: getPlainTexts(Title),
                        asset_display_text: CategoryName,
                        asset_position: assetPosition,
                        asset_element_position: index + 1,
                        momverse_stage: SegmentInfoObject?.type
                          ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                          : NON_ONBOARDED_STATUS,
                      });
                      router.push(ShopApiUrl);
                    }}
                    redirectUrl={ShopApiUrl}
                    bgShapeColor={index % 2 === 0 ? "#FAAE69" : "#9BACFF"}
                  />
                </div>
              );
            })}
          </div>
        )}
        <ButtonLink href={NEXT_PUBLIC_PHARMACY_BASE_URL} className={`btn`} color="primarybaby" size="lg">
          View all products
        </ButtonLink>
      </div>
    </section>
  );
};

export default Shop;
